// ─────────────────────────────────────────────────────────────────────────────
// RegionsCard.js — "Highest-Traffic Regions": the top 5 regions by volume, each
// as a bar relative to the busiest one.
//
// Unlike the BarChart above, this scale IS relative — the card ranks regions
// against each other, so the leader is 100% by definition and the label under it
// carries the absolute GB figure.
// ─────────────────────────────────────────────────────────────────────────────
import panel from "./panel.module.css";
import styles from "./RegionsCard.module.css";

const SKELETON_ROWS = 5;

function SkeletonRow({ index }) {
  return (
    <div className={styles.item}>
      <div className={styles.top}>
        {/* Staggered widths so the skeleton reads as a ranked list, not a grid. */}
        <span className={styles.skeletonBar} style={{ width: `${40 + index * 8}%` }} />
        <span className={styles.skeletonBar} style={{ width: 36 }} />
      </div>
      <div className={styles.track} />
    </div>
  );
}

/** @param {{regions: {name: string, gb: number}[] | null, loading: boolean}} props */
export default function RegionsCard({ regions, loading }) {
  const isLoading = regions === null || loading;
  // The list is sorted desc, so the first entry is the scale's 100%.
  const max = regions?.[0]?.gb ?? 1;

  return (
    <div className={panel.card}>
      <div className={panel.header}>Highest-Traffic Regions</div>
      <div className={styles.list}>
        {isLoading
          ? Array.from({ length: SKELETON_ROWS }, (_, i) => <SkeletonRow key={i} index={i + 1} />)
          : regions.length === 0
            ? <div className={styles.empty}>No data</div>
            : regions.map((r, i) => (
              <div key={i} className={styles.item}>
                <div className={styles.top}>
                  <span className={styles.name}>{r.name}</span>
                  <span className={styles.gb}>{r.gb} GB</span>
                </div>
                <div className={styles.track}>
                  <div className={styles.fill} style={{ width: `${(r.gb / max) * 100}%` }} />
                </div>
              </div>
            ))}
      </div>
    </div>
  );
}
